import Vue from 'vue';

/**
 * currency filter, responsible for formatting a number to localized currency
 */
export default Vue.filter('toCurrency', function (price) {
  if (typeof price !== "number") {
    return price;
  }
  var formatter = new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  return formatter.format(price);
});



// WEBPACK FOOTER //
// ./Vue/Src/Services/Filters.js